import { getSeriesByStudy } from "@api/series";
import useAuth from "@hooks/Auth/useAuth";
import { Series } from "@models/Series";
import { useQuery } from "@tanstack/react-query";
import { toCamelCase } from "utils/caseConverter";
import { useMemo } from "react";

interface useSeriesProps {
  study_id : string;
  getEnabled?: boolean;
  onSuccess?: () => void;
  onError?: () => void;
}

export default function useSeriesGroup({
  study_id = '',
  getEnabled = true,
}: useSeriesProps){
  const { accessToken } = useAuth();

  const {
    data,
    isLoading,
    isError,
    isSuccess,
    isFetching,
    refetch,
    error,
  } = useQuery({
    queryKey: ['studyGroup', study_id],
    queryFn: () =>
      getSeriesByStudy({
        accessToken,
        params: { id: study_id }
      }),
    enabled: getEnabled && !!accessToken,
    retry: false,
    refetchOnWindowFocus: false,
  });

  const Series = useMemo(() => {
    const rawData = data?.data ?? [];
    const camelData = toCamelCase<Series[]>(rawData);
    return { data : camelData };
  }, [data]);

  return {
    Series,
    isLoading,
    isError,
    isSuccess,
    isFetching,
    refetch,
    error,
  };
}
